import { useRef } from 'react';

import { emailRegexp } from './Utils/Validate.jsx';
import { API_ENDPOINTS } from './common';

export function Interaction(interactionId) {
    const interaction = useRef();
    const templateShowSegment = useRef();

    // Fetch segment
    const fetchInteraction = async () => {
        const interactionData = await fetch(API_ENDPOINTS.segment(interactionId), {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            if (response.status >= 400) {
                console.log(response);
                throw new Error("Server respond with error !");
            }
            else {
                return response.json();
            }
        });
        const templateData = await getTemplateShowSegment(interactionData.template_widget_model);
        interactionData.templateShowSegment = templateData;
        interaction.current = interactionData;
        return interaction.current;
    };

    /** Retourne les informations du widget model
     *  
     * @param {String} widgetModel : nom du widget
     */
    const getTemplateShowSegment = async (widgetModel) => {
        if (widgetModel) {
            const data = await fetch(API_ENDPOINTS.getTemplateShowSegmentByWidgetModel(widgetModel), {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            }).then(response => {
                if (response.status >= 400) {
                    console.log(response);
                    throw new Error("Server respond with error !");
                }
                else {
                    let a = response.json();
                    return a;
                }
            });

            if (data) {
                templateShowSegment.current = data
            }
            return templateShowSegment.current;
        }
    }
    return {
        fetchInteraction,
        interaction
    };
}
export function InitializeInteraction(
    interactionId,
    fetchInteraction,
    setInteraction,
    setCustomisation,
    setExtraUserInformationValid,
    setExtraUserInformation,
    setRememberMe,
    setDisplayPages,
    setNumberOfPages,
    setCurrentPage,
    setDisplayInformationToGather,
    setDisplayConsent
) {
    const initializeInteraction = async () => {
        // Get interaction data
        // Obtenir les données d'interaction
        const interactionData = await fetchInteraction(interactionId);
        // count page number regarding the options
        // Compter le nombre de page en fonction des options
        let numberOfPages = 1;
        setInteraction(interactionData);
        setCustomisation(interactionData.segment_customisation);
        // Initialise un tableau pour gérer la validation des champs
        // Initialize an array to deal with field validation
        Object.entries(interactionData.information_to_gather).map(e => {
            setExtraUserInformationValid((prev) => ({ ...prev, [e[0]]: true }));
            // Array.prototype.map() expects a return value from arrow function  
            return '';
        });
        // displayPage est utilisé pour gérer l'affichage des pages
        // displayPage is used to manage the display of the pages
        setDisplayPages((prev) => ({ ...prev, '1': true }));
        // S'il faut collecter des données il y a une seconde page masquée par défaut
        // Dans le cas d'une connexion SSO afficher la page seulement si des
        // informations sont à collecter

        // If informations have to be collected add a page which is hide at this stage
        // If a SSO connexion is setup display the page only if needed
        let displayInformationToGather = false;
        if (interactionData.gather_information) {
            let pageToAdd = true; // If only information to gather add the page
            if (interactionData.segment_customisation?.with_connexion) {
                pageToAdd = false; // If SSO connexion setup add the page only if there's more information to gather
                // eslint-disable-next-line
                for (const [unused, options] of Object.entries(interactionData.information_to_gather)) {
                    if (options['active'] === true) {
                        pageToAdd = true;
                        break;
                    }
                }
            }
            if (pageToAdd) {
                displayInformationToGather = true;
                numberOfPages += 1;
                setDisplayPages((prev) => ({ ...prev, numberOfPages: false }));
            }
        }
        setDisplayInformationToGather(displayInformationToGather);
        // S'il faut collecter des consentements ajouter une page masquée par défaut
        // If consents have to be collected add a page which is hide at this stage
        setDisplayConsent(false);
        if (interactionData.segment_customisation.image_right || interactionData.segment_customisation.consent_gdpr) {
            // TODO : mettre en place une gestion des consentements sur deux pages de manière automatique ?
            // Affichage des consentements sur la même page ou sur une page différente :
            // Si en commentaire sur la même page
            //numberOfPages += 1;
            setDisplayPages((prev) => ({ ...prev, numberOfPages: false }));
            setDisplayConsent(true);
        }
        setNumberOfPages(numberOfPages);
        setCurrentPage(1);

        // Retrieve saved extra user information
        // Récupérer les information utilisateur sauvegardées
        const previousSavedExtraUserInformation = JSON.parse(localStorage.getItem('extraUserInformation'));
        if (previousSavedExtraUserInformation) {
            Object.keys(previousSavedExtraUserInformation).forEach((key) => {
                setExtraUserInformation((prev) => ({ ...prev, [key]: previousSavedExtraUserInformation[key] }))
            });
            setRememberMe(true);
        }
        return interactionData;
    }
    return {
        initializeInteraction
    };

}

export function InteractionCommand(
    numberOfPages,
    interaction,
    extraUserInformation,
    setExtraUserInformationValid,
    setDisplayPages,
    currentPage,
    setCurrentPage,
    setProgress,
    sendParticipation,
    sendRecordParticipation = null,
    isText = true
) {
    const handleClick = (e) => {
        if (e.target.name === "continuer") {
            let error = false;
            if (numberOfPages > 1 && currentPage === 2) {
                // Appliquer les contrôles sur les champs
                Object.entries(interaction.information_to_gather).map(e => {
                    if (e[1].mandatory && !extraUserInformation[e[0]]) {
                        error = true;
                        setExtraUserInformationValid((prev) => ({ ...prev, [e[0]]: false }));
                    }
                    if (e[0] === "email" && extraUserInformation[e[0]]) {
                        let emailValid = emailRegexp.test(extraUserInformation[e[0]]);
                        error = error || !emailValid;
                        setExtraUserInformationValid((prev) => ({ ...prev, [e[0]]: emailValid }));
                    }
                    // Array.prototype.map() expects a return value from arrow function  
                    return '';
                });
            }
            if (!error) {
                setDisplayPages((prev) => ({ ...prev, [String(currentPage)]: false }));
                setDisplayPages((prev) => ({ ...prev, [String(currentPage + 1)]: true }));
                setCurrentPage(currentPage + 1);
                setProgress((currentPage + 1) / (numberOfPages + 1) * 100);
            }
        }
        if (e.target.name === "precedent") {
            setDisplayPages((prev) => ({ ...prev, [String(currentPage)]: false }));
            setDisplayPages((prev) => ({ ...prev, [String(currentPage - 1)]: true }));
            setCurrentPage(currentPage - 1);
            setProgress((currentPage - 1) / (numberOfPages + 1) * 100);
        }
        if (e.target.name === "envoyer") {
            if (isText) {
                sendParticipation();
            }
            else {
                sendRecordParticipation();
            }
        }
    };
    return {
        handleClick
    };
}
